import { FormValues } from '@topdanmark-onlinesolutions/claim-form-types';
import { AnimalPolicy } from '../../../types/services';
import ANIMAL_LABELS from './animal.json';

type ValidAnimalType = AnimalType;

type Option = {
    breed: string;
    name: string;
    policyNum: string;
};

export type AnimalType = 'cat' | 'dog' | 'horse';

export const ENTITY_MAP: Record<ValidAnimalType, AnimalPolicy['entity']> = {
    cat: 'KAT',
    dog: 'HUND',
    horse: 'HEST'
};

export const mapDataToOptions = (policies: AnimalPolicy[], animalType: AnimalType): Option[] => {
    const result: Option[] = [];

    policies.forEach((policy) => {
        if (policy.entity === ENTITY_MAP[animalType]) {
            result.push({
                breed: policy.object.breedName,
                name: titleCase(policy.object.petName),
                policyNum: policy.policyNo
            });
        }
    });

    result.push({
        breed: '',
        name: '',
        policyNum: 'OTHERS'
    });

    return result;
};

export const titleCase = (text: string): string => {
    if (!text) {
        return text;
    }

    if (text.indexOf(' ') > -1) {
        return text.split(' ').map(titleCase).join(' ');
    }

    return `${text[0].toUpperCase()}${text.slice(1).toLowerCase()}`;
};

export const otherAnimalLabels = {
    dog: {
        other: 'Anden hund',
        nameLabel: 'Skriv navnet på hunden',
        breedLabel: 'Skriv race på hunden'
    },
    cat: {
        other: 'Anden kat',
        nameLabel: 'Skriv navnet på katten',
        breedLabel: 'Skriv racen på katten'
    },
    horse: {
        other: 'Anden hest',
        nameLabel: 'Skriv navnet på hesten',
        breedLabel: 'Skriv racen på hesten'
    }
};

export const getLabels = () => ({
    dog: {
        ...ANIMAL_LABELS.dog,
        addNewText: 'Anden hund',
        nameLabel: 'Skriv navnet på hunden',
        breedLabel: 'Skriv race på hunden'
    },
    cat: {
        ...ANIMAL_LABELS.cat,
        addNewText: 'Anden kat',
        nameLabel: 'Skriv navnet på katten',
        breedLabel: 'Skriv racen på katten'
    },
    horse: {
        ...ANIMAL_LABELS.horse,
        addNewText: 'Anden hest',
        nameLabel: 'Skriv navnet på hesten',
        breedLabel: 'Skriv racen på hesten'
    }
});

export const getAnimalIconFromType = (animalType: string) => {
    switch (animalType) {
        case 'dog':
        case 'cat':
            return 'animal-' + animalType;

        case 'horse':
            return 'horse';

        default:
            return '';
    }
};

export const WhichAnimalTypeMap: Record<string, AnimalType> = {
    Kat: 'cat',
    Hund: 'dog',
    Hest: 'horse'
};

export const getAnimalType = (
    formValues: FormValues,
    elementId: string | undefined,
    petType: AnimalType | undefined
): AnimalType => {
    if (elementId === undefined) {
        return petType!;
    } else {
        return WhichAnimalTypeMap[formValues[elementId].value];
    }
};

// // vanilla
// let petData: AnimalServiceData | null = null;
// export const getFetchedPetData = () => {
//     return petData;
// };
// export const setFetchedPetData = (fetchedData: AnimalServiceData | null) => {
//     petData = fetchedData;
// };
